import * as React from 'react';
import { useUserId } from '../../auth';
import { FullScreenMessage } from '../../components/FullScreenMessage';
import { ListButton } from '../../components/ListButton';
import { config } from '../../config';
import { useUpdateUser, useUser } from '../../data/users';
import { useRouteMatch } from "../../hooks";
import { Storage } from '../../storage';
import styled from 'styled-components/native';

const Container = styled.View`
  border-radius: ${(props) => props.theme.borderRadius}px;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  background-color: white;
`;


export function TermsAgreement() {
  const dontShowOn = useRouteMatch(['/welcome', '/login', '/sign-up']);
  const myId = useUserId();
  const { user } = useUser(myId);
  const { updateUser } = useUpdateUser();
  const [isAgreeing, setIsAgreeing] = React.useState(false);
  const [hasAcceptedThisSession, setHasAcceptedThisSession] = React.useState(false);
  const [persistedAcceptedTermsVersion, setPersistedAcceptedTermsVersion] = React.useState<string | undefined>();

  const currentTermsVersion = config.legal.terms.currentVersion;
  const acceptedTermsVersion = user?.acceptedTermsVersion || persistedAcceptedTermsVersion;

  React.useEffect(() => {
    if (!myId) {
      return;
    }

    Storage.getItem(`accepted-terms-${myId}`, { persist: true }).then((storedVersion) => {
      setPersistedAcceptedTermsVersion(storedVersion || undefined);
    });
  }, [myId]);

  const open = Boolean(!dontShowOn && user && currentTermsVersion !== acceptedTermsVersion && !hasAcceptedThisSession);

  const message = user?.acceptedTermsVersion ? "Our terms have been updated" : "Please accept our terms"

  return (
    <>
      <FullScreenMessage
        title={message}
        subtitle="Please review the terms below"
        component={
          <Container>
            <ListButton 
              label={'View Terms'}
              to='https://flametask.com/terms'
              newTab
            />
            <ListButton 
              label={'Agree'}
              loading={isAgreeing}
              onPress={async () => {
                if (!myId) return;
                setIsAgreeing(true);
                try {
                  await updateUser(myId, { acceptedTermsVersion: currentTermsVersion });
                  await Storage.setItem(`accepted-terms-${myId}`, currentTermsVersion, { persist: true });
                  setPersistedAcceptedTermsVersion(currentTermsVersion);
                  setHasAcceptedThisSession(true);
                } finally {
                  setIsAgreeing(false);
                }
              }}
            />
          </Container>
        }
        opened={open}
      />
    </>
  )
}
